import { defaultApi } from '@/plugins/api/defaultApi'
import { defaultV2Api } from '@/plugins/api/defaultV2Api'

export default {
  name: 'wholesaler',
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getNowWholesalerDate({ dispatch }) {
      const result = dispatch('product/getNowProductDate', null, { root: true })
      return result
    },
    async addWholesalerFile({}, file) {
      const { data } = await defaultApi.postWholesalerListFiles(file)
      return data
    },
    async deleteWholesalerFile({}, { uuid }) {
      const { data } = await defaultApi.deleteWholesalerFiles({ uuid })
      return data
    },
    async getWholesalerFiles({}, { date }) {
      const {
        data: { results },
      } = await defaultApi.getWholesalerFiles({ date })
      return results
    },
    async getWholesalerDetail({}, { uuid }) {
      const { data } = await defaultV2Api.getWholesalerDetail(uuid)
      return data
    },
    async addWholesaler({}, wholesaler) {
      const { data } = await defaultApi.postWholesaler(wholesaler)
      return data
    },
    async addWholesalerAccount({}, wholesaler) {
      const { data } = await defaultApi.postWholesalerAccount(wholesaler.wholesaler, wholesaler)
      return data
    },
    async getWholesalers({}, { search }) {
      const {
        data: { results },
      } = await defaultApi.getWholesalers({ search })

      return results
    },
  },
}
